import { AdministrativeQueryCategory } from "./administrative-query-category";

export class AdministrativeQuery {
    id: number;
    subject: string;
    user_email: string;
    entry_datetime: Date;
    status: string;
    category: AdministrativeQueryCategory;
}